module.exports = __webpack_public_path__ + "b0283dee9c90e29b02ace5a172540bb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/ch_grid_5-mobile.png
// module id = 128
// module chunks = 1